(() => {
  const focusableSelector = 'a[href],button,input,select,textarea,[tabindex]';

  const patchRoot = (root) => {
    root.querySelectorAll?.('[aria-hidden="true"]').forEach((container) => {
      if (container.matches?.(focusableSelector)) container.setAttribute('tabindex', '-1');
      container.querySelectorAll?.(focusableSelector).forEach((el) => el.setAttribute('tabindex', '-1'));
    });

    root.querySelectorAll?.('slideshow-slides,.menu-list__scroll-container,.rte-table-wrapper,[data-horizontal-scroll]').forEach((el) => {
      const isScrollable = el.scrollWidth > el.clientWidth + 2;
      if (isScrollable) {
        if (!el.hasAttribute('tabindex') || el.getAttribute('tabindex') === '-1') el.setAttribute('tabindex', '0');
        if (el.matches('.rte-table-wrapper') && !el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable data table');
      } else if (el.matches('slideshow-slides,.menu-list__scroll-container') && el.getAttribute('tabindex') === '0') {
        el.removeAttribute('tabindex');
      }
    });

    root.querySelectorAll?.('.product-recommendations__skeleton-item[aria-label]').forEach((el) => {
      el.removeAttribute('aria-label');
      el.setAttribute('aria-hidden', 'true');
    });

    root.querySelectorAll?.('*').forEach((el) => {
      if (el.shadowRoot) patchRoot(el.shadowRoot);
    });
  };

  const patch = () => patchRoot(document);

  let queued = false;
  const queuePatch = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      patch();
    });
  };

  document.addEventListener('DOMContentLoaded', queuePatch, { once: true });
  window.addEventListener('resize', queuePatch, { passive: true });
  new MutationObserver(queuePatch).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'aria-label', 'tabindex', 'class']
  });
  queuePatch();
})();